import {
  useQuery as reactQueryUseQuery,
  useQueryClient,
  keepPreviousData
} from '@tanstack/react-query';
import { CancelToken } from 'axios';

import useAxios from './useAxios';

const useQuery = ({
  queryKey,
  ...options
}) => {
  const {
    enabled: passedEnabled = true,
    baseUrl,
    token,
    clientId,
    browserUrl,
    setting,
    variables,
    channelDriverName,
    ...useQueryOptions
  } = options;

  const axios = useAxios({
    baseUrl,
    token,
    clientId,
    browserUrl,
    setting,
    variables,
    channelDriverName
  });

  const isInTest = process.env.NODE_ENV === 'test';

  const queryFunction = async ({ queryKey }) => {
    const [key, params] = queryKey;

    const source = CancelToken.source();

    const promise = axios.get(
      key,
      {
        cancelToken: source.token,
        params,
      }
    );

    promise.cancel = () => {
      source.cancel('Query was cancelled by React Query');
    };

    const { data } = await promise;

    return data;
  };

  const queryClient = useQueryClient();

  const isGloballyDisabled = !queryClient.getDefaultOptions().queries.enabled;

  const query = reactQueryUseQuery({
    queryKey,
    queryFn: isInTest
      ? queryClient.getDefaultOptions().queries.queryFn
      : queryFunction,
    enabled: isGloballyDisabled ? false : passedEnabled,
    ...useQueryOptions
  });

  return query;
};

export { keepPreviousData };
export default useQuery;
